import component from './ru-RU/component';
import globalHeader from './ru-RU/globalHeader';
import menu from './ru-RU/menu';
import pages from './ru-RU/pages';
import pwa from './ru-RU/pwa';
import settingDrawer from './ru-RU/settingDrawer';
import settings from './ru-RU/settings';
import fixOverlay from './ru-RU/fix_overlay';
import fixOpenapi from './ru-RU/fix_openapi';
import fixAdminMisc from './ru-RU/fix_adminmisc';
import fixBilling from './ru-RU/fix_billing';
import fixComponents from './ru-RU/fix_components';
import fixConsoleMisc from './ru-RU/fix_consolemisc';
import fixGap from './ru-RU/fix_gap';
import fixSystemconfig from './ru-RU/fix_systemconfig';
import fixTenant from './ru-RU/fix_tenant';
import fixVoiceClone from './ru-RU/fix_voiceclone';
import fixTodo from './ru-RU/fix_todo';


export default {
  'navBar.lang': 'Язык',
  'layout.user.link.help': 'Помощь',
  'layout.user.link.privacy': 'Конфиденциальность',
  'layout.user.link.terms': 'Условия',
  'app.preview.down.block': 'Скачать эту страницу в локальный проект',
  'app.welcome.link.fetch-blocks': 'Получить все блоки',
  'app.welcome.link.block-list': 'На основе block-разработки быстро создайте стандартные страницы',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
